import React from 'react';
import { SOURCE_KIND_LABEL, isOfficialKind } from '../format';
import type { SourceKind } from '../types';

/**
 * Whether a source is the state's own act or publication, or a report of
 * one. The map rests on the first; news only confirms.
 */
export const SourceKindTag: React.FC<{ kind?: SourceKind | null }> = ({ kind }) =>
  kind ? (
    <span
      className={`rounded px-1 text-[10.5px] leading-4 ${
        isOfficialKind(kind) ? 'bg-emerald-50 text-emerald-700' : 'bg-neutral-100 text-neutral-500'
      }`}
      title={isOfficialKind(kind) ? 'An official act or publication' : 'Confirmation only'}
    >
      {SOURCE_KIND_LABEL[kind]}
    </span>
  ) : null;
